__turbopack_context__.v({
  "aspectBox": "CardRecipeGrid-module-scss-module__HugYKW__aspectBox",
  "category": "CardRecipeGrid-module-scss-module__HugYKW__category",
  "categoryWrapper": "CardRecipeGrid-module-scss-module__HugYKW__categoryWrapper",
  "creator": "CardRecipeGrid-module-scss-module__HugYKW__creator",
  "fade-in": "CardRecipeGrid-module-scss-module__HugYKW__fade-in",
  "favoriteButtonContainer": "CardRecipeGrid-module-scss-module__HugYKW__favoriteButtonContainer",
  "image": "CardRecipeGrid-module-scss-module__HugYKW__image",
  "infoLockup": "CardRecipeGrid-module-scss-module__HugYKW__infoLockup",
  "infoWrapper": "CardRecipeGrid-module-scss-module__HugYKW__infoWrapper",
  "inner": "CardRecipeGrid-module-scss-module__HugYKW__inner",
  "root": "CardRecipeGrid-module-scss-module__HugYKW__root",
  "timeIcon": "CardRecipeGrid-module-scss-module__HugYKW__timeIcon",
  "timeLabel": "CardRecipeGrid-module-scss-module__HugYKW__timeLabel",
});
